import { navigate } from 'hookrouter'
import { useProject } from 'hooks/useProject'
import { useUser } from 'hooks/useCompany'
import { useProjectsForCompany } from 'hooks/useProjectsForCompany'
import React, { FC, useEffect } from 'react'
import { NavDropdown } from 'react-bootstrap'
import { UrlParams } from 'types'
import { usePermissions } from 'hooks/useCompanyManagers'
import { getPermissionsList } from 'state/async_actions'
import { useAppContext } from 'state/context'


export const DefaultDropdownText = 'Pick a Project'
export const CreateProjectText = '+ Create a Project'

export const ActiveProjectNavSelector: FC<UrlParams> = ({
  companyId,
  projectId,
}) => {
  const [, dispatch] = useAppContext()
  const activeProject = useProject(projectId)
  const activeCompanyProjects = useProjectsForCompany(companyId)
  const user = useUser();
  const project:any = activeCompanyProjects.find((company:any) => company.id === projectId) || {}

  activeCompanyProjects.filter((p:any, idx) => {
  if(p.status == "inactive"){
    let item:any = activeCompanyProjects.splice(idx, 1);
    activeCompanyProjects.push(...item)
  }
})

  let userRoleType = 1;
  if (project.isCompanyManager)
    userRoleType = 1;
  else if (project.isProjectManager)
    userRoleType = 2;
  else if (project.isSuperForeman)
    userRoleType = 3;
  else if (project.isSubCordinator)
    userRoleType = 4;
  else if (project.isProjectCoordinator)
    userRoleType = 5;

useEffect(() => {
  if(companyId)
    getPermissionsList(dispatch, companyId, userRoleType)
}, [dispatch, projectId, userRoleType])

const permissionsList:any = usePermissions(userRoleType);

  const navigateToNewProjectForm = () =>
    navigate(`/company/${companyId}/new_project`)

  const dropdown = (
    <NavDropdown
      title={activeProject ? activeProject.name : DefaultDropdownText}
      id="project-nav-dropdown"
      className="project-name">
      {activeCompanyProjects
        .filter(project =>
          activeProject ? activeProject.id !== project.id : true,
        )
        .sort((a:any, b:any) => a.status !== b.status ? a.status < b.status ? -1 : 1 : 0)
        .map((project:any) => {
          const onSelect = () =>
            navigate(`/company/${companyId}/project/${project.id}`)
          return (
            
            <NavDropdown.Item key={project.id} onSelect={onSelect}>
              {project.status == 'active' && <span>{project.name}</span>}
              {project.status == 'inactive' && <span style={{color: 'red'}}>{project.name} - Closed</span>}
            </NavDropdown.Item>
          )
        })}
      {(user.isAdmin || user.isCompanyManager || user.isProjectCoordinator || user.isProjectManager) && permissionsList?.project?.can_create && <NavDropdown.Item onSelect={navigateToNewProjectForm}>
        {CreateProjectText}
      </NavDropdown.Item>}
    </NavDropdown>
  )

  const disabled = (
    <NavDropdown
      disabled
      title={DefaultDropdownText}
      id="company-nav-dropdown"
    />
  )

  return companyId ? dropdown : disabled
}
